import { useMemo, useState } from "react";

import { AddMedicationModal } from "components/AddMedicationModal";
import { AddPrescriptionModal } from "components/AddPrescriptionModal/AddPrescriptionModal";
import { useDataTableSelection } from "components/ui/DataTable/hooks/useDataTableSelection";
import { usePaginatedAcuteMedications } from "features/medications/hooks/usePaginatedAcuteMedications";

import { DrugsTable } from "../DrugsTable/DrugsTable.jsx";
import s from "./AcuteMedication.module.css";

const AcuteMedication = ({ patientId, deleteDrug }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState(20);
  const selection = useDataTableSelection();

  const { data, isLoading, isError, refetch } =
    usePaginatedAcuteMedications(
      patientId,
      currentPage,
      searchQuery,
      rows === "All" ? 9999 : rows
    );

  const medications = useMemo(() => [...(data?.data || [])], [data]);
  const totalRecords = data?.totalRecords || 0;

  const selectedMedications = useMemo(
    () =>
      medications
        .filter((med) => selection.isSelected(med.id))
        .map((med) => ({ ...med, usageType: "ACUTE" })),
    [medications, selection]
  );

  return (
    <div className={s.longTermWrapper}>
      <div className={s.topWrapper}>
        <h3 className={s.title}>Acute medications history</h3>
        <div className={s.buttonGroup}>
          <AddMedicationModal usageType="ACUTE" />
          {selection.selectedCount > 0 && (
            <AddPrescriptionModal
              initialMedications={selectedMedications}
              isRenewal={true}
            />
          )}
        </div>
      </div>
      <DrugsTable
        items={medications}
        isLoading={isLoading}
        isError={isError}
        errorLabel="this patient's acute medications"
        onRetry={refetch}
        emptyTitle="No Acute prescriptions"
        selection={selection}
        deleteDrug={deleteDrug}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        totalRecords={totalRecords}
        rows={rows}
        setRows={setRows}
      />
    </div>
  );
};

export { AcuteMedication };
